<template>
    <div class="main">
        <c-panel title="Nova reserva" titleIcon="fas fa-bookmark">
            <reserva-form @onSubmit="onSubmit"></reserva-form>
        </c-panel>
    </div>
</template>
<script>
import ReservaForm from "./form"

export default {
    components:{ 'reserva-form': ReservaForm },
    methods: {
        onSubmit(){
            this.$router.push('/admin/biblioteca/reserva');
        }
    }
}
</script>
